import { catchError } from 'rxjs/operators';
import { of as observableOf, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface NotebookLibrary {
  name: string;
  desc?: string;
  url?: string;
  version?: string;
}

export interface NotebookSection {
  prepend?: string;
  append?: string;
  libraries?: NotebookLibrary[];
}

interface NotebookDescription {
  description: string;
  notebook: string;
  service: string;
  title: string;
  sections?: NotebookSection[];
}

export interface NotebookNotebook {
  display_name: string;
  restricted: boolean;
  description: NotebookDescription;
}

export interface DescriptionData {
  scope: string;
  customer: string;
  notebooks: NotebookNotebook[];
}

export interface IDescriptionService {
  getDescription(): Observable<DescriptionData | null>;
}

@Injectable()
export class DescriptionService implements IDescriptionService {
  readonly apiUrl: string = '/api/descriptions/';
  description$: Observable<DescriptionData | null>;

  constructor(private _http: HttpClient) {}

  getDescription(): Observable<DescriptionData | null> {
    return this._http.get<DescriptionData | null>(this.apiUrl).pipe(
      catchError(error => {
        console.log('in catch: ' + JSON.stringify(error));
        return observableOf(null);
      })
    );
  }
}
